import { AccessDeniedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import {
  ValidateTranferResult,
  ValidateTransfer,
  ValidateTransferRequest,
} from "../../domain/usecases/validate-transfer";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbValidateTransfer implements ValidateTransfer {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async validate(
    params: ValidateTransferRequest
  ): Promise<ValidateTranferResult> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        return res.body;
    }
  }
}
